import React from 'react';
import PropTypes from 'prop-types';

const RenderSvg = (props) => {
  const { width, height, viewBox, fillRule, clipRule, svgPath } = props;
  return(
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fillRule={fillRule}
      clipRule={clipRule}
    >
      <path d={svgPath} />
    </svg>
  );
}

RenderSvg.propTypes = {
  svgPath: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  fillRule: PropTypes.string,
  clipRule: PropTypes.string,
}

RenderSvg.defaultProps = {
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};

class Icons {
  Social = {
    Facebook() {
      return(
        <RenderSvg
          svgPath="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333
            1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
        />
      );
    }
  }

  Media = {
    Play() {
      return(
        <RenderSvg
          svgPath="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l10 6-10 6z"
        />
      );//M23 12l-22 12v-24l22 12zm-21 10.315l18.912-10.315-18.912-10.315v20.63z
    }
  }

  Quote = {
    Open() {
      return(
        <RenderSvg
          svgPath="M24 11.871l-5-4.871v3h-19v4h19v3z"
        />
      );
    }
  }
}

const icons = new Icons();

export default icons;
